import { StudentProfileResponse } from '../../../services/studentProfileService';

/**
 * Billed / paid / outstanding across a person's challans (cancelled ones
 * excluded), what was given back, and the advance they hold from their
 * (active) receipts. `netPaid` is what the family has paid less refunds.
 */
export const feeTotals = ({ invoices, payments, refunds }: StudentProfileResponse['fees']) => {
  const live = invoices.filter((inv: any) => inv.status !== 'cancelled');
  const billed = live.reduce((s: number, inv: any) => s + (inv.totals?.net ?? 0), 0);
  const paid = live.reduce((s: number, inv: any) => s + (inv.totals?.paid ?? 0), 0);
  const outstanding = live.reduce((s: number, inv: any) => s + Math.max(0, inv.totals?.outstanding ?? 0), 0);
  const advance = payments.reduce((s: number, p: any) => s + (p.advanceAmount ?? 0) - (p.fromAdvance ?? 0), 0);
  const refunded = refunds.reduce((s, r) => s + r.amount, 0);
  return {
    billed, paid, refunded, netPaid: paid - refunded, outstanding,
    advance: Math.round(advance * 100) / 100,
    openCount: live.filter((inv: any) => (inv.totals?.outstanding ?? 0) > 0).length,
  };
};
